import { render, staticRenderFns } from "./saldos_vencidos.vue?vue&type=template&id=524c9155"
import script from "./saldos_vencidos.vue?vue&type=script&lang=js"
export * from "./saldos_vencidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports